import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';
import AllEvents from "../../components/Shop/AllSalesEvents";

const ShopAllEvents = () => {
  return (
    <div className="shop-management-page">
        <DashboardHeader />
        <div className="shop-management-layout">
            <div className="shop-management-sidebar-slot">
              <DashboardSideBar active={11} />
            </div>
            <main className="shop-management-main-panel">
              <ShopManagementPageHero
                eyebrow="Sales Events"
                title="All Sales Events"
                copy="Review active sale events, inventory counts, pricing, previews, and cleanup actions."
              />
                <AllEvents />
            </main>
          </div>
    </div>
  )
}

export default ShopAllEvents